
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProtectedAdminRoute } from "@/components/ProtectedAdminRoute";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Management from "./pages/Management";
import Client from "./pages/Client";
import Users from "./pages/Users";
import Staff from "./pages/Staff";
import Plans from "./pages/Plans";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import MySubscriptions from "./pages/MySubscriptions";
import PublicSubscriptions from "./pages/PublicSubscriptions";
import PublicProductSubscription from "./pages/PublicProductSubscription";
import Subscriptions from "./pages/Subscriptions";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";
import TransactionHistory from "./pages/TransactionHistory";
import Discounts from "./pages/Discounts";
import Payment from "./pages/Payment";
import BillingWebhook from "./pages/BillingWebhook";
import SubscriptionStatusWebhook from "./pages/SubscriptionStatusWebhook";
import PricingApiDoc from "./pages/PricingApiDoc";
import SchoolApiDoc from "./pages/SchoolApiDoc";
import AdminUsers from "./pages/AdminUsers";
import SampleLinks from "./pages/SampleLinks";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Toaster />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/management" element={
            <ProtectedAdminRoute>
              <Management />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/dashboard" element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          } />
          <Route path="/client" element={
            <ProtectedAdminRoute>
              <Client />
            </ProtectedAdminRoute>
          } />
          <Route path="/users" element={
            <ProtectedAdminRoute>
              <Users />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin-users" element={
            <ProtectedAdminRoute>
              <AdminUsers />
            </ProtectedAdminRoute>
          } />
          <Route path="/staff" element={
            <ProtectedAdminRoute>
              <Staff />
            </ProtectedAdminRoute>
          } />
          <Route path="/plans" element={
            <ProtectedAdminRoute>
              <Plans />
            </ProtectedAdminRoute>
          } />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/subscriptions" element={<MySubscriptions />} />
          <Route path="/subscriptions/public" element={<PublicSubscriptions />} />
          <Route path="/product" element={<PublicProductSubscription />} />
          <Route path="/admin/subscriptions" element={
            <ProtectedAdminRoute>
              <Subscriptions />
            </ProtectedAdminRoute>
          } />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={
            <ProtectedAdminRoute>
              <Settings />
            </ProtectedAdminRoute>
          } />
          <Route path="/discounts" element={
            <ProtectedAdminRoute>
              <Discounts />
            </ProtectedAdminRoute>
          } />
          {/* Making the payment route accessible without admin protection for testing */}
          <Route path="/payment" element={<Payment />} />
          <Route path="/transaction-history/:schoolId" element={
            <ProtectedAdminRoute>
              <TransactionHistory />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/billing-webhook" element={
            <ProtectedAdminRoute>
              <BillingWebhook />
            </ProtectedAdminRoute>
          } />
          <Route path="/admin/subscription-status-webhook" element={
            <ProtectedAdminRoute>
              <SubscriptionStatusWebhook />
            </ProtectedAdminRoute>
          } />
          <Route path="/pricing-api-docs" element={<PricingApiDoc />} />
          <Route path="/admin/school-api-docs" element={<SchoolApiDoc />} />
          <Route path="/sample-links" element={<SampleLinks />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
